import bridge from "@vkontakte/vk-bridge";
import {setSnackbar} from "../../redux/reducers/profile-reducer";
import {MySnackbar} from "../../components/MySnackbar";
import React from "react";

function bridgeCopyText(text, dispatch) {
  bridge.send('VKWebAppCopyText', { text: text })
    .then( () => dispatch(setSnackbar(<MySnackbar message={'Скопировано'}/>)))}

export default bridgeCopyText